import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import { putCPDataWithParams } from 'src/clinic/services'
import { EVENT_TYPE_CONSULTATION, MOMENT_FORMATS } from 'src/consumer/constants'
import { platformWeb } from 'src/consumer/services'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessful,
} from 'src/mentor/helpers/utilityFunctions'
import { v4 as uuidv4 } from 'uuid'

async function createBooking(
  meetingBookApiSignature,
  {
    isUsingClinicAppointmentType = false,
    paymentGateway,
    mentorId,
    startTimeInDayJs,
    eventMode,
    eventType,
    eventDurationInMins,
    eventFee,
    feeCurrency,
    patientId,
    clinicId,
    clinicBrandId,
    eventTypeId,
    subscriptionPlanId,
    mentorAssignment,
    bookScreeningAutomatically = false,
    notScreeningReason,
    feePaymentMode,
    feePaidTxnId,
    feeCollectionNote,
    sendLinkToPatient,
    sendLinkToRelative,
    customPhonesToSendLinkTo,
    triggeringBookedEventId,
    bundlePackPurchaseId,
  },
) {
  //   let paymentGateway
  //   if (askPayment) {
  //     if (holdSlotAndSendPaymentLink) {
  //       if (returnPaymentLink) {
  //         paymentGateway = 'paymentLinkOnScreen'
  //       } else {
  //         paymentGateway = 'paymentLinkInitiatedByMentor'
  //       }
  //     } else {
  //       paymentGateway = 'paidOffline'
  //     }
  //   } else {
  //     paymentGateway = 'free'
  //   }
  //   if (overridePaymentGateway) {
  //     paymentGateway = overridePaymentGateway
  //   }
  //   console.log({ paymentGateway, returnPaymentLink })

  console.log({
    mentorId,
    eventMode,
    eventDurationInMins,
    eventFee,
    feeCurrency,
    patientId,
    clinicId,
    clinicBrandId,
    eventTypeId,
    subscriptionPlanId,
    feePaymentMode,
    feePaidTxnId,
    mentorAssignment,
    eventType,
    sendLinkToPatient,
    sendLinkToRelative,
    customPhonesToSendLinkTo,
    triggeringBookedEventId,
    bundlePackPurchaseId,
  })

  const clientTransactionId = uuidv4()
  const isCreditsBooking = paymentGateway === 'credits'

  const dataToSubmit = {
    apiParam: 'booked-event-info',
    mentorId: mentorId,
    userId: '',
    eventType: eventType,
    startTime: dayjs?.utc(startTimeInDayJs)?.format('YYYY-MM-DD HH:mm:ss'),
    mode: eventMode,
    eventDuration: eventDurationInMins,
    endTime:
      eventDurationInMins &&
      dayjs
        ?.utc(startTimeInDayJs)
        .add(eventDurationInMins, 'minutes')
        ?.format('YYYY-MM-DD HH:mm:ss'),
    eventTypeId: eventTypeId,
    subscriptionPlanId: subscriptionPlanId,
    patientId: patientId,
    id: '',
    feePaid: isCreditsBooking ? '' : eventFee,
    currency: feeCurrency || 'inr',
    useClinicServices: isUsingClinicAppointmentType,
    // feePaymentMode: askPayment ? offlinePaymentDetails?.feePaymentMode : '',
    clinicId: clinicId || '',
    clinicBrandId: clinicBrandId || '',
    feePaymentMode: isCreditsBooking ? '' : feePaymentMode,
    feePaidTxnId: isCreditsBooking ? '' : feePaidTxnId,
    feeCollectionNote: isCreditsBooking ? '' : feeCollectionNote || '',
    bookingTime: dayjs()?.format(MOMENT_FORMATS.formatThatServerSends),
    screeningRequest: {
      requested: bookScreeningAutomatically,
      reasonId: notScreeningReason?.id || '',
      reason: notScreeningReason?.title || '',
    },
    ...(bundlePackPurchaseId ? { bundlePackPurchaseId } : {}),
    ...(triggeringBookedEventId ? { triggeringBookedEventId: triggeringBookedEventId } : {}),
  }
  let response
  let createdBookedEventData = null
  // distinction between clinic assistant api and mentor api

  //   if (forMentor) {
  response = await putCPDataWithParams(meetingBookApiSignature, dataToSubmit, {
    mentorAssignmentType: mentorAssignment,
    teacherId: mentorId,
    paymentGateway: paymentGateway,
    bookScreeningAutomatically:
      eventType === EVENT_TYPE_CONSULTATION ? bookScreeningAutomatically : null,
    clientTransactionId: clientTransactionId,
    platform: platformWeb,
    paymentMethod: 'upi',
    ...(sendLinkToPatient ? { sendPaymentLinkToPatient: sendLinkToPatient } : {}),
    ...(sendLinkToRelative ? { sendPaymentLinkToPatientRelative: sendLinkToRelative } : {}),
    ...(customPhonesToSendLinkTo?.length > 0
      ? {
          phoneNumbersToSendThePaymentLink: customPhonesToSendLinkTo.join(','),
        }
      : {}),
    cancelUrl: encodeURIComponent(window.location.href),
    successUrl: encodeURIComponent(window.location.href),
  })
  //   } else {
  //     const params = {
  //       teacherId: teacherId,
  //       paymentGateway: paymentGateway,
  //       clientTransactionId: clientTransactionId,
  //       platform: platformWeb,
  //       paymentMethod: 'upi',
  //       cancelUrl: encodeURIComponent(window.location.href),
  //       successUrl: encodeURIComponent(window.location.href),
  //       bookScreeningAutomatically: tryBookingScreening,
  //       referenceConsultationId: selectedRelatedConsultationForTherapy,
  //     }
  //     response = await putCPDataWithParams(`/api/secure/meeting/book`, dataToSubmit, params)
  //   }

  let dataToReturn = null
  if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
    toast.success('Booked session')
    createdBookedEventData = getDataMapFromCommonResponse(response)?.bookedEvent
    if (response?.data?.data?.userPaymentLink?.paymentLink) {
      try {
        navigator.clipboard.writeText(response?.data?.data?.userPaymentLink?.paymentLink)
      } catch (e) {
        console.error('Error copying payment link to clipboard', e)
      }
      toast.info('Payment Link copied to clipboard')
      dataToReturn = { ...dataToReturn, userPaymentLink: response?.data?.data?.userPaymentLink }
      toast.info('Payment Link sent to client')
    }
  } else {
    toast.error('Error Booking Session')
    return null
  }
  return { ...dataToReturn, ...createdBookedEventData }
}

export async function createUnAssignedBooking(meetingBookApiSignature, params) {
  return createBooking(meetingBookApiSignature, {
    ...params,
    mentorAssignment: 'later',
    mentorId: null,
  })
}

export async function createRegularBooking(meetingBookApiSignature, params) {
  return createBooking(meetingBookApiSignature, {
    ...params,
    mentorAssignment: 'preferred',
  })
}

export function getBookingMethodByMentorId(mentorId) {
  console.log({ mentorId })
  switch (mentorId) {
    case undefined:
    case null:
    case 'un-assigned':
      return createUnAssignedBooking
    default:
      return createRegularBooking
  }
}
